import React from 'react'
import useLookupService from '../../../../services/lookup/useLookupService'
import * as resultConsiderationTypes from './resultConsiderationTypes'
import useTranslate from '../../../../i18n/useTranslate'
import useEditSynthesis from '../../shareLogic/useEditSynthesis'
import { useForm } from 'react-final-form'

const useResultConsideration = (props: resultConsiderationTypes.UseResultConsiderationType) => {
    const { irb, onChangStatus, isCommitee, submitTypeID } = props
    const callLookup = useLookupService()
    const translate = useTranslate()
    const form = useForm()
    const editSynthesis = useEditSynthesis({ form })

    const [approveStatus, setApproveStatus] = React.useState<resultConsiderationTypes.OptType[]>([])

    React.useEffect(() => {
        if (irb) {
            getApproveStatus()
        }
    }, [translate.languageStore.currentLanguage])

    const getApproveStatus = async () => {
        let res
        if (irb) {
            if (isCommitee === null || isCommitee === undefined) {
                res = await callLookup.callApproveStatusLut(irb, submitTypeID)
            } else {
                res = await callLookup.callApproveStatusLutProjectRenewal(irb, isCommitee)
            }
        }

        const formatedData = res?.result?.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        }) as []
        setApproveStatus(formatedData)
    }

    const handleChangStatus = (val: resultConsiderationTypes.OptType) => {
        onChangStatus(val)
    }

    return {
        approveStatus,
        useAccordionMode: editSynthesis.useAccordionMode,
        onChangeStatus: handleChangStatus,
        updateApproveStatus: editSynthesis.updateApproveStatus,
    }
}

export default useResultConsideration
